export default (function (node) {
  if (node === (node === null || node === void 0 ? void 0 : node.window)) {
    return node;
  }

  return (node === null || node === void 0 ? void 0 : node.nodeType) === 9 ? (node === null || node === void 0 ? void 0 : node.defaultView) || (node === null || node === void 0 ? void 0 : node.parentWindow) : null;
});